import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const userDetails = JSON.parse(sessionStorage.getItem('userDetails'));

  if (!userDetails || (userDetails.role !== 3 && userDetails.role !== 4)) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default ProtectedRoute;
